import { render, staticRenderFns } from "./VxPagination.vue?vue&type=template&id=b2083ab6&"
import script from "./VxPagination.vue?vue&type=script&lang=js&"
export * from "./VxPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports